export const SET_POLL_INTERVAL = 'SET_POLL_INTERVAL';
export const SET_SERVICE_LEVEL = 'SET_SERVICE_LEVEL';
export const SET_TIME_RANGE = 'SET_TIME_RANGE';
export const START_POLLING = 'START_POLLING';
export const STOP_POLLING = 'STOP_POLLING';
export const UPDATE_DATA = 'UPDATE_DATA';
export const TOGGLE_DRAG = 'TOGGLE_DRAG';
export const TOGGLE_RESIZE = 'TOGGLE_RESIZE';
export const SET_SELECTED_QUEUES = "SET_SELECTED_QUEUES";